/**
 * @author：
 * @update：
 * @description：
 **/
import { refundSeach, refundRefuse, refundConsent } from "@/api/refund";
import { fileEcho, fileUp } from "@/api/url";
import { userInfoHeaderHttp } from "@/config/config";
export default {
    data () {
        return {
            id: '',//url id
            loading: true,
            fileUp,
            dialogVisible: false,
            token: { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') },
            priviewDialogVisible: false,
            refuseForm: {
                deliveryCostRefunded: true,
            },
            isAggreeOrRefund: true,
            dialogImageUrl: '',
            fileList: [],
            hideUploadEdit: false,
            tableData: {
                order: {
                    store: {
                        name: '',
                        contact: {

                        }
                    }
                },
                orderItem: {
                    goodsName: '',
                    goodsImage: {
                        location: ''
                    }
                },
                certificates: [],
                userInfo: {
                    nickname: '',
                    mobile: ''
                }
            },
            tableDataLoc: fileEcho,
            userImg: userInfoHeaderHttp,
            statusText: '',//交易状态文字
        };
    },
    // 自定义方法
    methods: {
        // on-change添加文件、上传成功和上传失败时都会被调用
        handleEditChange (file, fileList) {
            this.hideUploadEdit = fileList.length >= 5;
            this.fileList = fileList;
        },
        handleRefuse () {
            if (this.isAggreeOrRefund) {
                this.refundConsent();
            } else {
                this.refundRefuse();
            }
        },
        // before-upload上传文件之前的钩子 -- 限制文件大小
        beforeAvatarUpload (file) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        handleClose (next) {
            this.fileList = [];
            this.refuseForm.refuseReason = '';
            next();
        },
        refundConsent () {
            this.$ajax.post(refundConsent(this.id), {
                id: this.id,
                deliveryCostRefunded: false
            }).then((res) => {
                this.$router.go(-1);
                this.dialogVisible = false;
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
            }, (err) => {
                this.$message.error(err.data);
            });
        },
        refundRefuse () {
            if (!this.refuseForm.refuseReason) {
                this.$message.error('拒绝退款原因不得为空');
                return;
            }
            let fileArr = [];
            for (let i = 0; i < this.fileList.length; i++) {
                delete this.fileList[i].response.id;
                fileArr.push({
                    type: 'IMAGE',
                    label: this.fileList[i].name,
                    file: this.fileList[i].response
                });
            }
            console.log(fileArr, 'fileArr');
            let fromData = {
                id: this.id,
                refuseReason: this.refuseForm.refuseReason,
                refuseCertificates: fileArr
            };
            this.$ajax.post(refundRefuse(this.id),
                fromData).then((res) => {
                    this.$router.go(-1);
                    this.$message({
                        type: 'success',
                        message: '更新成功!'
                    });
                    this.fileList = [];
                    this.refuseForm.refuseReason = '';
                }, (err) => {
                    this.$message.error(err.data);
                });
        },
        agree () {
            this.isAggreeOrRefund = true;
            this.dialogVisible = true;
        },
        refuse () {
            this.isAggreeOrRefund = false;
            this.dialogVisible = true;
        },
        handleRemove (file, fileList) {
            this.fileArr = fileList;
        },
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url;
            this.priviewDialogVisible = true;
        },
        //获取数据
        getList () {
            this.$ajax.get(refundSeach(this.id)).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data;
                    // 凭证
                    let certificatesList = [];
                    res.data.certificates.forEach(item => {
                        certificatesList.push(this.tableDataLoc + item.location);
                    });
                    this.tableData.certificatesList = certificatesList;
                    //处理
                    let arr = [];
                    res.data.list.forEach(item => {
                        if (item.hasOwnProperty('refuseCertificates')) {
                            item.refuseCertificates.forEach(items => {
                                arr.push(this.tableDataLoc + items.location);
                            });
                        }
                    });
                    console.log(arr);
                    this.tableData.imgList = arr;
                    if (this.tableData.status == 'TOREFUND') {
                        this.statusText = '等待商家处理';
                    } else if (this.tableData.status == 'REFUNDED') {
                        this.statusText = '退款成功';
                    } else if (this.tableData.status == 'REFUSED') {
                        this.statusText = '商家拒绝退款';
                    } else if (this.tableData.status == 'CANCELED') {
                        this.statusText = '退款关闭';
                    }
                }
            }, (err) => {
                console.log(err);
            });
        },
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate () {

    },
    // 组件数据创建完成
    created () {
        if (this.$route.query.id != undefined) {
            this.id = window.atob(this.$route.query.id);//详情的id
            this.getList();
        }
    },
    // 组件挂载完成之前
    beforeMount () {

    },
    // 组件挂载完成
    mounted () {

    },
    // 组件即将销毁
    beforeDestroy () {

    },
    // 组件销毁
    destroyed () {

    },
    // 组件激活
    activated () {

    },
    // 组件冻结
    deactivated () {

    }
};
